<script setup lang="ts">
  import { IconImage, Tooltip } from '@/shared/ui';
  import PencilIcon from '@/shared/assets/icons/PencilGray.svg';
  import TrashIcon from '@/shared/assets/icons/TrashIcon.svg';

  defineProps<{
    id: number;
    name: string;
  }>();

  const emit = defineEmits<{
    edit: [id: number];
    delete: [id: number];
  }>();
</script>

<template>
  <tr class="border-b border-gray-02 last:border-b-0">
    <td class="pl-6 py-4 text-sm text-gray-07 text-left">
      {{ name }}
    </td>
    <td class="pr-6 py-4 w-26">
      <div class="flex gap-2 justify-end items-center text-gray-xx-02">
        <Tooltip
          content="Editar"
          placement="top"
        >
          <button
            type="button"
            @click="emit('edit', id)"
          >
            <IconImage
              :src="PencilIcon"
              alt="Editar"
            />
          </button>
        </Tooltip>
        <Tooltip
          content="Deletar"
          placement="top"
        >
          <button
            type="button"
            @click="emit('delete', id)"
          >
            <IconImage
              :src="TrashIcon"
              alt="Deletar"
            />
          </button>
        </Tooltip>
      </div>
    </td>
  </tr>
</template>
